// Human Resources Skills organized by subcategories
export const HUMAN_RESOURCES_SKILLS_CATEGORIES = [
  {
    name: 'Recruitment and Selection',
    skills: [
      'Talent Acquisition', 'Job Analysis', 'Job Description Development',
      'Candidate Sourcing', 'Resume Screening', 'Interview Techniques',
      'Assessment Methods', 'Selection Process', 'Background Verification',
      'Offer Management', 'Recruitment Strategy', 'Employer Branding',
      'Candidate Experience', 'Recruitment Analytics', 'Talent Pipeline'
    ]
  },
  {
    name: 'Employee Relations',
    skills: [
      'Conflict Resolution', 'Employee Engagement', 'Performance Management',
      'Workplace Culture', 'Employee Communication', 'Policy Implementation',
      'Grievance Handling', 'Employee Advocacy', 'Team Building',
      'Workplace Diversity', 'Employee Recognition', 'Change Management',
      'Labor Relations', 'Employee Feedback', 'Workplace Harmony'
    ]
  },
  {
    name: 'Training and Development',
    skills: [
      'Training Needs Analysis', 'Program Development', 'Learning Design',
      'Training Delivery', 'Skills Assessment', 'Career Development',
      'Leadership Development', 'Mentoring Programs', 'Performance Coaching',
      'E-learning Development', 'Training Evaluation', 'Competency Management',
      'Professional Development', 'Knowledge Transfer', 'Learning Technology'
    ]
  },
  {
    name: 'Compensation and Benefits',
    skills: [
      'Salary Administration', 'Benefits Management', 'Compensation Planning',
      'Payroll Management', 'Incentive Programs', 'Rewards Strategy',
      'Market Analysis', 'Job Evaluation', 'Equity Management',
      'Benefits Analysis', 'Total Rewards', 'Cost Analysis',
      'Compensation Structure', 'Performance Rewards', 'Benefits Communication'
    ]
  },
  {
    name: 'HR Administration',
    skills: [
      'HR Policies', 'Documentation Management', 'Employee Records',
      'HR Systems', 'Process Improvement', 'Compliance Management',
      'Data Management', 'Report Generation', 'HR Analytics',
      'Budget Management', 'Vendor Management', 'Project Management',
      'Quality Assurance', 'System Implementation', 'Process Automation'
    ]
  },
  {
    name: 'HR Strategy',
    skills: [
      'Strategic Planning', 'Workforce Planning', 'Organizational Development',
      'Change Management', 'Succession Planning', 'Talent Management',
      'HR Metrics', 'Business Partnership', 'Performance Strategy',
      'Culture Development', 'Innovation Management', 'Risk Management',
      'Strategic Analysis', 'Program Development', 'Leadership Alignment'
    ]
  },
  {
    name: 'Legal Compliance',
    skills: [
      'Employment Law', 'Policy Development', 'Regulatory Compliance',
      'Risk Assessment', 'Audit Management', 'Documentation Control',
      'Training Programs', 'Investigation Management', 'Compliance Monitoring',
      'Legal Research', 'Policy Implementation', 'Reporting Requirements',
      'Compliance Strategy', 'Legal Updates', 'Compliance Training'
    ]
  },
  {
    name: 'HRIS and Technology',
    skills: [
      'HR Software', 'Data Analytics', 'System Implementation',
      'Digital HR', 'Technology Integration', 'Process Automation',
      'Reporting Tools', 'Database Management', 'User Training',
      'System Optimization', 'Technology Strategy', 'Data Security',
      'Vendor Management', 'System Administration', 'Digital Transformation'
    ]
  },
  {
    name: 'Performance Management',
    skills: [
      'Performance Evaluation', 'Goal Setting', 'Performance Metrics',
      'Feedback Systems', 'Development Planning', 'Review Process',
      'Performance Analytics', 'Competency Assessment', 'Performance Improvement',
      'Rating Systems', 'Performance Documentation', 'Coaching Methods',
      'Performance Strategy', 'Talent Assessment', 'Success Planning'
    ]
  },
  {
    name: 'Organizational Development',
    skills: [
      'Change Management', 'Culture Development', 'Team Building',
      'Leadership Development', 'Organizational Design', 'Process Improvement',
      'Talent Strategy', 'Succession Planning', 'Performance Enhancement',
      'Program Development', 'Strategic Planning', 'Innovation Management',
      'Organization Assessment', 'Change Implementation', 'Culture Assessment'
    ]
  },
  {
    name: 'Employee Wellness',
    skills: [
      'Wellness Programs', 'Health Promotion', 'Work-Life Balance',
      'Mental Health Support', 'Stress Management', 'Safety Programs',
      'Wellness Education', 'Program Development', 'Health Assessment',
      'Wellness Strategy', 'Benefits Integration', 'Program Evaluation',
      'Employee Support', 'Health Resources', 'Wellness Communication'
    ]
  },
  {
    name: 'Diversity and Inclusion',
    skills: [
      'Diversity Strategy', 'Inclusion Programs', 'Cultural Awareness',
      'Equal Opportunity', 'Diversity Training', 'Inclusive Recruitment',
      'Policy Development', 'Program Implementation', 'Diversity Metrics',
      'Cultural Competence', 'Bias Prevention', 'Diversity Communication',
      'Inclusion Assessment', 'Diversity Planning', 'Equity Programs'
    ]
  }
];

// Export flattened list for backward compatibility
export const HUMAN_RESOURCES_SKILLS = HUMAN_RESOURCES_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
